import { FormGroup, ValidatorFn } from '@angular/forms';
import { parse, startOfDay } from 'date-fns';

export function nextDate(anchorDateControlName: string, targetDateControlPath: string): ValidatorFn {
  return (group) => {
    const anchorDateControl = (group as FormGroup).get(anchorDateControlName);
    const targetDateControl = (group as FormGroup).get(targetDateControlPath);
    targetDateControl?.updateValueAndValidity({ onlySelf: true, emitEvent: false })

    if (!anchorDateControl?.value || !targetDateControl?.value) return null

    if (anchorDateControl.value > targetDateControl.value) targetDateControl.setErrors({ invalidDate: true })
    return null
  }
}

export function futureDate(): ValidatorFn {
  return (control) => {
    if (!control.value) return null
    const now = new Date()
    return startOfDay(parse(control.value, 'yyyy-MM-dd', now)) < now ? { invalidDate: true } : null;
  }
}

export function matchValidator(originFieldName: string): ValidatorFn {
  return (control) => {
    const password = control?.parent?.get(originFieldName)?.value;
    const confirm = control?.value;
    return password && confirm && password !== confirm ? { mismatch: true } : null;
  }
}
